import { Injectable } from '@angular/core';
import { DataProvider } from '../../providers/data/data';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../assets/vfs/vfs_fonts';
import logo from './prescriptionLogo';

pdfMake.vfs = pdfFonts;

/*
  Generated class for the PrescriptionProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

/*
   Demo of params needed:

   'lang'         : 'zh',
   'pat_name'     : 'Leung Fei Fan',
   'date'         : '2018-09-10',
   'phy_name'     : 'KELLY CHAIN YEUNG PUI KUEN',
   'phy_title'    : 'Registered Chinses Medicine Practitioner',
   'phy_reg_no'   : '004494',
   'dispensary'   : [ obj ],
   'address_en'   : "15/F, Regent Centre, 88 Queen's Road, Central, Hong Kong",
   'address_zh'   : "中環皇后大道中 88 號勵精中心 15 樓",
   'tel'          : '2525 9288 / 2525 9919',
   'fax'          : '2525 6168',
   'url'          : 'www.chains.hk'
*/

@Injectable()
export class PrescriptionProvider
{

   public pdfObj = null;


   /** ----- Constructor ----- **/

   constructor(private data: DataProvider) {}


   /** ----- Public Methods ----- **/

   create = ( inParams ) => {
     console.log('inParams', inParams);

      return new Promise( resolve => {
         // pack PDF content
         let content: any = [];

         // dispensary may be null
         // filter list and only show disp item on prescription
         const pureDispensary = inParams[ 'dispensary' ] ? inParams[ 'dispensary' ].filter(item => this.checkDisp(item)) : []

         // loop every dispensary
         for ( let i = 0; i < pureDispensary.length; i++ ) {
            let prescriptTitle = ( inParams[ 'lang' ] == 'zh' ) ? "處方" : "Prescription";
            prescriptTitle += " " + ( i + 1 );
            let currentContent: any = [
               {
                  image: 'data:image/png;base64,' + logo,
                  fit: [ 70, 66 ], style: 'image'
                  // pageBreak: 'after'
               },
               {
                  table: {
                     widths: [ '*', 'auto', '*' ],
                     body: [
                        [
                           { border: [ false, false, false, false ], text: '' },
                           { border: [ false, false, false, true ], text: prescriptTitle, style: ( inParams[ 'lang' ] == 'zh' ) ? 'headerTC' : 'header' },
                           { border: [ false, false, false, false ], text: '' }
                        ]
                     ]
                  },
                  layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return null; },
                     paddingBottom  : function( i, node ) { return null; }
                  }
               },
               {
                  table: {
                     widths: [ 75, 5, '*' ],
                     body: [
                        [
                           { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '日期：' : 'Date:', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                           { border: [ false, false, false, false ], text: '' },
                           { border: [ false, false, false, false ], text: '' + inParams[ 'date' ], style: 'itemContent' }
                        ]
                     ]
                  },
                  layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return null; },
                     paddingBottom  : function( i, node ) { return null; }
                  }
               },
               {
                  table: {
                     widths: [ 75, 5, '*' ],
                     body: [
                        [
                           { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '姓名：' : 'Name:', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                           { border: [ false, false, false, false ], text: '' },
                           { border: [ false, false, false, false ], text: '' + inParams[ 'pat_name' ], style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' }
                        ]
                     ]
                  },
                  layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return null; },
                     paddingBottom  : function( i, node ) { return 5; }
                  }
               }
            ];

            // only pageBreak if not first item
            if ( i > 0 ) currentContent[ 0 ][ 'pageBreak' ] = "before";


           /** Dispensary **/
           let dispObj = {
             table: {
               widths: [ 75, 5, '*' ],
               body: [
                 [
                   { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '處方：' : 'Prescription:', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                   { border: [ false, false, false, false ], text: '' },
                   { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '免煎中藥顆粒，每包含以下份量' : 'Each packet contains following ingredients', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
                 ],
                 [
                   { border: [ false, false, false, false ], text: '' },
                   { border: [ false, false, false, false ], text: '' },
                   { border: [ false, false, false, false ], ul: [], style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
                 ]
               ]
             },
             layout: {
               paddingLeft    : function( i, node ) { return null; },
               paddingRight   : function( i, node ) { return null; },
               paddingTop     : function( i, node ) { return null; },
               paddingBottom  : function( i, node ) { return null; }
             }
           };

           if ( pureDispensary[ i ][ 'data' ].length > 0 ) {
             // loop each data in dispensary content
             for ( let j = 0; j < pureDispensary[ i ][ 'data' ].length; j++ ) {
               // get current dispensary object
               let currentDispObj = pureDispensary[ i ][ 'data' ][ j ];

               // Dispensary - Single
               if ( currentDispObj[ 'hidden' ] != true && currentDispObj[ 'type' ] == 'disp-single' ) {
                 // creare a row and prepare string to be displayed
                 let contentStr = '';
                 contentStr += ( inParams[ 'lang' ] == 'zh' ) ? currentDispObj[ 'details'] [ 'name_zh' ] : currentDispObj['details'][ 'name_en' ];
                 contentStr += '   ' + currentDispObj[ 'details'][ 'default' ] + ' g';
                 dispObj[ 'table' ][ 'body' ][ 1 ][ 2 ][ 'ul' ].push( contentStr );
               }
               // Dispensary - Grouped
               else if ( currentDispObj[ 'hidden' ] != true && currentDispObj[ 'type' ] == 'disp-grouped' ) {
                 // creare a row and prepare string to be displayed
                 let contentStr = '';
                 contentStr += ( inParams[ 'lang' ] == 'zh' ) ? this.data.getDispGrpById(currentDispObj.details).name_zh : this.data.getDispGrpById(currentDispObj.details).name_en;
                 // not show undefined
                 if (currentDispObj[ 'default' ]) contentStr += '   ' + currentDispObj[ 'default' ] + ' g';

                 // creare a row and prepare string to be displayed
                 let detailStr = '(';
                 for ( let k = 0; k < currentDispObj[ 'data' ].length; k++ )
                 {
                   let tempSingle = this.data.getDispSingleById( currentDispObj[ 'data' ][ k ].id)
                   detailStr +=  inParams[ 'lang' ] == 'zh'  ? tempSingle.name_zh : tempSingle.name_en ;
                   if ( k < currentDispObj[ 'data' ].length - 1 ) detailStr += ( inParams[ 'lang' ] == 'zh' ) ? '，' : ',';
                 }
                 detailStr += ')';

                 let table = {
                   table: {
                     widths: [ '*' ],
                     body: [
                       [
                         { border: [ false, false, false, false ], text: contentStr, style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' }
                       ],
                       [
                         { border: [ false, false, false, false ], text: detailStr, style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
                       ]
                     ]
                   },
                   layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return null; },
                     paddingBottom  : function( i, node ) { return null; }
                   }
                 };

                 dispObj[ 'table' ][ 'body' ][ 1 ][ 2 ][ 'ul' ].push( table );
               }
               // Dispensary - Pills
               else if ( currentDispObj[ 'hidden' ] != true && currentDispObj[ 'type' ] == 'disp-pills' ) {
                 // creare a row and prepare string to be displayed
                 let contentStr = '';
                 contentStr += ( inParams[ 'lang' ] == 'zh' ) ? '－ ' : '-  ';
                 contentStr += ( inParams[ 'lang' ] == 'zh' ) ? this.data.getDispPillById(currentDispObj.details.id).name_zh : this.data.getDispPillById(currentDispObj.details.id).name_en;
                 contentStr += '   ' + currentDispObj['details'][ 'default' ] + ' g';

                 // creare a row and prepare string to be displayed

                 // let detailStr = '(';
                 // for ( let k = 0; k < currentDispObj[ 'data' ].length; k++ )
                 // {
                 //    detailStr += currentDispObj[ 'data' ][ k ][ ( inParams[ 'lang' ] == 'zh' ) ? 'item_name_zh' : 'item_name_en' ];
                 //    if ( k < currentDispObj[ 'data' ].length - 1 ) detailStr += ( inParams[ 'lang' ] == 'zh' ) ? '，' : ',';
                 // }
                 // detailStr += ')';

                 let table = {
                   table: {
                     widths: [ '*' ],
                     body: [
                       [
                         { border: [ false, false, false, false ], text: contentStr, style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' }
                       ],
                       [
                         { border: [ false, false, false, false ], text: "", style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
                       ]
                     ]
                   },
                   layout: {
                     paddingLeft    : function( i, node ) { return null; },
                     paddingRight   : function( i, node ) { return null; },
                     paddingTop     : function( i, node ) { return null; },
                     paddingBottom  : function( i, node ) { return null; }
                   }
                 };

                 dispObj[ 'table' ][ 'body' ][ 1 ][ 2 ][ 'ul' ].push( table );
               }
             }
           }

           // push dispensary into the list
           console.log( 'disp: ' + dispObj );
           if ( dispObj != null ) currentContent.push( dispObj );

           currentContent.push({

             table: {
               widths: [ 75, 5, '*' ],
               body: [
                 [
                   { border: [ false, false, false, false ], text: '' },
                   { border: [ false, false, false, false ], text: '' },
                   { border: [ false, false, false, false ], text: '' }
                 ]
               ]
             },
             layout: {
               paddingLeft    : function( i, node ) { return null; },
               paddingRight   : function( i, node ) { return null; },
               paddingTop     : function( i, node ) { return null; },
               paddingBottom  : function( i, node ) { return 5; }
             }
           });

           /** Usage **/
           let usageObj = {
             table: {
               widths: [ 75, 5, '*' ],
               body: [
                 [
                   { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '服法：' : 'Administration:', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                   { border: [ false, false, false, false ], text: '' }
                 ]
               ]
             },
             layout: {
               paddingLeft    : function( i, node ) { return null; },
               paddingRight   : function( i, node ) { return null; },
               paddingTop     : function( i, node ) { return null; },
               paddingBottom  : function( i, node ) { return null; }
             }
           };

           if ( pureDispensary[ i ][ 'usage' ].length > 0 ) {
             let usageStr = '';
             for ( let j = 0; j < pureDispensary[ i ][ 'usage' ].length; j++ )
             {
               let usageObj = pureDispensary[ i ][ 'usage' ][ j ];
               if ( usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].indexOf( '(' ) > -1 && usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].indexOf( ')' ) > -1 )
               {
                 let startIdx = usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].indexOf( '(' );
                 let endIdx = usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].indexOf( ')' ) + 2;
                 usageStr += usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].substring( 0, startIdx ) + usageObj[ 'default' ] + " " + usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].substring( endIdx, usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ].length );
               }
               else
               {
                 usageStr += usageObj[ ( inParams[ 'lang' ] == 'zh' ) ? 'zh' : 'en' ];
               }
             }

             let usage = {
               border: [ false, false, false, false ],
               text: usageStr,
               style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent'
             };

             usageObj[ 'table' ][ 'body' ][ 0 ].push( usage );
             usageObj[ 'table' ][ 'body' ].push(
               [
                 { border: [ false, false, false, false ], text: '', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                 { border: [ false, false, false, false ], text: '' },
                 { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '禁忌：不宜使用茶水、牛奶或其他飲品開服。' : 'Contradiction: Avoid mixing with tea and milk.', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
               ]
             );
             usageObj[ 'table' ][ 'body' ].push(
               [
                 { border: [ false, false, false, false ], text: '', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemTitleTC' : 'itemTitle' },
                 { border: [ false, false, false, false ], text: '' },
                 { border: [ false, false, false, false ], text: ( inParams[ 'lang' ] == 'zh' ) ? '醫囑：忌生冷食物，避風寒，調情志。' : 'Avoid eating cold and raw food, relax and take things easy.', style: ( inParams[ 'lang' ] == 'zh' ) ? 'itemContentTC' : 'itemContent' }
               ]
             );
           }

           // push usage into the list
           currentContent.push( usageObj );

           content.push( currentContent );
         }


         /** Document Definition **/
         let docDefinition ={
            content: content,
            footer: [
              {
                style: 'sign',
                columns: [
                  {},
                  {
                    table: {
                      widths: [ '*' ],
                      body: [
                        [
                          { border: [ false, true, false, false ], text: '' + inParams[ 'phy_name' ].toUpperCase(), style: 'sign1' }
                        ],
                        [
                          { border: [ false, false, false, false ], text: '' + inParams[ 'phy_title' ], style: 'sign2' }
                        ],
                        [
                          { border: [ false, false, false, false ], text: 'Registration NO. ' + inParams[ 'phy_reg_no' ], style: 'sign3',margin: [ 0, 0, 0, 10 ]  }
                        ]
                      ]
                    },
                    layout: {
                      paddingLeft    : function( i, node ) { return null; },
                      paddingRight   : function( i, node ) { return null; },
                      paddingTop     : function( i, node ) { return null; },
                      paddingBottom  : function( i, node ) { return null; }
                    }
                  }
                ]
              },
               {
                  columns: [
                     { width: '*', text: '' },
                     { width: 'auto', text: inParams[ 'address_en' ] + " | ", style: 'footer' },
                     { width: 'auto', text: " " + inParams[ 'address_zh' ], style: 'footerTC' },
                     { width: '*', text: '' }
                  ]
               },
               { text: "T: " + inParams[ 'tel' ] + " | F: " + inParams[ 'fax' ] + " | " + inParams[ 'url' ], style: 'footer' }
            ],
            styles:
            {
               footer: {

                  alignment: 'center',
                  fontSize: 7,
                  color: '#757575'
               },
               footerTC: {

                  alignment: 'center',
                  fontSize: 7,
                  font: 'Arial-Unicode-MS',
                  color: '#757575'
               },
               image: {

                  alignment: 'center'
               },
               header: {

                  margin: [ 0, 5, 0, 0 ],
                  bold: true,
                  fontSize: 10,
                  alignment: 'center'
               },
               headerTC: {

                  margin: [ 0, 5, 0, 0 ],
                  bold: true,
                  font: 'Arial-Unicode-MS',
                  fontSize: 10,
                  alignment: 'center'
               },
               itemTitleTC: {
                  font: 'Arial-Unicode-MS',
                  bold: true,
                  fontSize: 10,
               },
               itemTitle: {
                  bold: true,
                  fontSize: 10
               },
               itemContent: {
                  fontSize: 10
               },
               itemContentTC: {
                  font: 'Arial-Unicode-MS',
                  fontSize: 10,
               },
               itemContentRemark: {
                  margin: [ 0, 18, 0, 0 ],
                  fontSize: 10,
                  alignment: 'center'
               },
               sign: {
                  margin: [ 0, 60, 10, 0 ]
               },
               sign1: {
                  alignment: 'center',
                  bold: true,
                  fontSize: 10
               },
               sign2: {
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
               },
               sign3: {
                  alignment: 'center',
                  bold: true,
                  fontSize: 9
               }
            },
            defaultStyle: {
               font: 'Arial-Unicode-MS'
            },
            pageSize: 'A5',
            pageOrientation: 'portrait',
            pageMargins: [ 20, 30,20, 150 ],
         };

         // setup fonts
         pdfMake.fonts = {
            'Arial-Unicode-MS': {
               normal: 'Arial-Unicode-MS.ttf',
               bold: 'Arial-Unicode-MS.ttf'
            }
         };

         // create PDF file
         this.pdfObj = pdfMake.createPdf(docDefinition);
         resolve();
      });
   }

   // check the dispensary item is disp
   checkDisp( inObj ) {
      for ( let i = 0; i < inObj[ 'data' ].length; i++ ) {
         if (inObj[ 'data' ][ i ][ 'type' ] != 'disp-single'
           && inObj[ 'data' ][ i ][ 'type' ] != 'disp-grouped'
           && inObj[ 'data' ][ i ][ 'type' ] != 'disp-pills') {
            return false;
         }
      }
      return true;
   }
}



// WEBPACK FOOTER //
// ./src/providers/prescription/prescription.ts